import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectHomeId } from 'src/store/selectors/home'
import { selectClientHomes } from 'src/store/selectors/client'
import history from 'src/history'

const SubNavContainer = compose(
  connect((state, props) => {
    const homeId = selectHomeId(state)
    const homes = selectClientHomes(state) || []
    const loadingHomes = state.client.loadingHomes
    const loaded = homes.length && !loadingHomes

    return {
      homeId,
      homes,
      loaded: homes.length && !loadingHomes,
      addHomePath: loaded ? 'new' : null,
      navAddHome: id => history.push(id)
    }
  })
)

export default SubNavContainer
